import {useLocalStorage} from 'react-use';

export default function useRedirectPath() {
	return useLocalStorage<string>('redirectPath');
}
